export const PROGRAM_REFRESH = 60000;
export const DEFAULT_GENRE_SELECTED = 'All';

export const today = new Date();
export const tomorrow = new Date(today);
tomorrow.setDate(today.getDate() + 1); // Move to next day

export const since = new Date();
since.setHours(0, 0, 0);
export const till = new Date();
till.setHours(23, 59, 59);
